import { create } from 'zustand';
import { Filter } from '@libs/models/common';
import { QualificationListItem } from '@libs/models/qualifications';
import { fetchQualificationsList } from '@libs/api/qualifications';

type InitialState = {
  initialized: boolean;
  loadingList: boolean;
  qualifications: QualificationListItem[];
  page: number;
  perPage: number;
  total: number;
  load: (filters?: Filter[], page?: number, perPage?: number) => Promise<void>;
};

export const useQualificationsListStore = create<InitialState>()((set) => ({
  initialized: false,
  loadingList: false,
  qualifications: [],
  page: 1,
  perPage: 50,
  total: 0,

  load: async (filters, page = 1, perPage = 50) => {
    set({ loadingList: true });
    try {
      const resp = await fetchQualificationsList({ filters, page, size: perPage });
      set({
        loadingList: false,
        initialized: true,
        qualifications: resp.items,
        page,
        perPage,
        total: resp.totalCount,
      });
    } finally {
      set({ loadingList: false, initialized: true });
    }
  },
}));
